import React from "react";

const PdfContext = React.createContext()

export default PdfContext
